import { FC } from 'react';

import { Box, Typography, useTheme } from '@mui/material';

interface OffersCardProps {
    title: string;
    children: React.ReactNode;
}

const OffersCard: FC<OffersCardProps> = ({ title, children }) => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                width: '100%',
                height: '355px',
                backgroundColor: theme.palette.background.default,
                borderRadius: '16px',
                boxShadow: theme.shadows[1],
                border: `0.5px solid ${theme.palette.orange.main}`,
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    backgroundColor: theme.palette.primary.main,
                    height: '64px',
                    borderRadius: '16px 16px 0 0',
                    padding: '0px 16px',
                }}
            >
                <Typography color="#fff" fontSize={20}>
                    {title}
                </Typography>
            </Box>
            <Box
                sx={{
                    overflowY: 'auto',
                    '&::-webkit-scrollbar': {
                        width: '6px',
                        backgroundColor: 'rgba(0, 0, 0, 0.1)',
                        borderRadius: '3px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        borderRadius: '3px',
                    },
                }}
            >
                {children}
            </Box>
        </Box>
    );
};

export default OffersCard;
